import { render, staticRenderFns } from "./ListItemRanking.vue?vue&type=template&id=19cf4571&scoped=true"
import script from "./ListItemRanking.vue?vue&type=script&lang=js"
export * from "./ListItemRanking.vue?vue&type=script&lang=js"
import style0 from "./ListItemRanking.vue?vue&type=style&index=0&id=19cf4571&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cf4571",
  null
  
)

export default component.exports